import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Loader } from "./CenteredContent";

const NoPermission = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 3000);
    return () => clearTimeout(timer);
  }, []);

  if (loading) {
    return (
      <div className="flex items-center justify-center h-full bg-gray-50">
        <Loader />
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center h-full bg-gray-50">
      <div className="bg-white rounded-2xl text-center w-[420px] border border-gray-100 shadow-[0_4px_6px_-1px_rgba(0,0,0,0.05),0_20px_40px_-8px_rgba(0,0,0,0.08)] overflow-hidden relative px-10 py-12">

        <div className="absolute top-0 left-0 right-0 h-[3px] bg-gradient-to-r from-red-500 to-orange-400" />

        <div className="w-16 h-16 rounded-[18px] bg-gradient-to-br from-red-50 to-orange-50 border border-red-100 flex items-center justify-center text-3xl mx-auto mb-6">
          🔒
        </div>

        <h2 className="text-[20px] font-bold text-slate-900 tracking-tight mb-2">
          Access Denied
        </h2>

        <p className="text-sm text-slate-500 leading-relaxed mb-8 max-w-[280px] mx-auto">
          You don't have permission to view this page. Please contact your <strong className="text-slate-700">workspace admin</strong> to request access.
        </p>

        <button
          onClick={() => navigate(-1)}
          className="inline-flex items-center gap-2 bg-gradient-to-r from-slate-700 to-slate-800 text-white px-7 py-2.5 rounded-xl text-sm font-semibold shadow-lg shadow-slate-700/20 hover:-translate-y-0.5 hover:shadow-slate-700/30 transition-all duration-200"
        >
          ← Go Back
        </button>
      </div>
    </div>
  );
};

export default NoPermission;
